import {Component, OnInit, signal} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {CommonModule} from '@angular/common';
import {BountyMerchantCardComponent} from './bounty-merchant-card/bounty-merchant-card.component';
import {GhostMerchantBountyService} from '../../services/ghost-merchant-bounty.service';
import {GhostMerchantBounty} from '../../services/models/ghost-merchant-bounty';

@Component({
  selector: 'app-ghost-merchant-bounty-list',
  imports: [
    TranslocoDirective,
    CommonModule,
    BountyMerchantCardComponent
  ],
  templateUrl: './ghost-merchant-bounty-list.component.html',
  styleUrl: './ghost-merchant-bounty-list.component.scss'
})
export class GhostMerchantBountyListComponent implements OnInit {
  bounties = signal<GhostMerchantBounty[]>([]);

  constructor(private ghostMerchantBountyService: GhostMerchantBountyService) {
  }

  ngOnInit(): void {
    this.loadBounties();
  }

  private loadBounties(): void {
    this.ghostMerchantBountyService.getUserBounties().subscribe(bounties => {
      this.bounties.set(bounties);
    });
  }
}
